module.exports = __webpack_public_path__ + "static/Grafik_PDF-Download@2x.775f2acf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GrafikPDFDownload/Grafik_PDF-Download@2x.png
// module id = 421
// module chunks = 35783957827783